module.exports = __webpack_public_path__ + "img/plate.518f1cfb.png";